import { Download } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TerraformProviderVersionArtifact } from "types/generated";

import useDownloadArtifact from "../../useDownloadArtifact";

type ArtifactWithContext = TerraformProviderVersionArtifact & {
  providerId: string;
  versionNumber: string;
};

const ProviderVersionArtifactsDownloadCell = ({
  item: artifact,
  ...cellProps
}: TableSimpleCellProps<ArtifactWithContext>) => {
  const { handleDownloadArtifact, loading } = useDownloadArtifact({
    providerId: artifact.providerId,
    versionNumber: artifact.versionNumber,
  });

  return (
    <TableSimpleCell {...cellProps}>
      <Box align="center">
        <ButtonIcon
          onPress={() => handleDownloadArtifact(artifact)}
          variant="secondary"
          size="small"
          disabled={loading}
          icon={Download}
          tooltipPlacement="left"
        >
          Download artifact
        </ButtonIcon>
      </Box>
    </TableSimpleCell>
  );
};

export default ProviderVersionArtifactsDownloadCell;
